import request from "@/utils/request";

export default function adminAddEditNews(params) {
    return request({
        url: `/news/agencyAddEdit`,
        method: 'post',
        data: params
    })
}
